import { render, staticRenderFns } from "./FreightTableCarga.vue?vue&type=template&id=dc093c70&scoped=true"
import script from "./FreightTableCarga.vue?vue&type=script&lang=js"
export * from "./FreightTableCarga.vue?vue&type=script&lang=js"
import style0 from "./FreightTableCarga.vue?vue&type=style&index=0&id=dc093c70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc093c70",
  null
  
)

export default component.exports